import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import LookupsHelper from 'lib/LookupsHelper';
import {
  TooltipButton,
  TooltipLink,
  formatCurrency,
  formatCurrencyRounded,
  PartyTypes,
  AuctionStatuses,
} from 'vdlib';

import part from '../../static/img/part.png';

import Tooltip from 'antd/lib/tooltip';

import _ from 'lodash';

import {
  FileTextOutlined,
  EditOutlined,
  ClockCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
} from '@ant-design/icons';

import model from '../../static/img/model.png';
import modelTruck from '../../static/img/truck48.png';
import modelOther from '../../static/img/other48.png';
import modelMoto from '../../static/img/motocyrcle48.png';
import modelPickup from '../../static/img/pickup48.png';

import moment from 'moment';
import 'moment/locale/el';

import { getBidsTooltipCellRenderer } from 'components/tables/datagrid-columns/BidsTooltipCellRenderer';
import TimeCellRenderer from 'components/tables/datagrid-columns/TimeCellRenderer';
import {
  getLowestBidAmountDiffCellRenderer,
  getMerchantLowestBidAmount,
  getSelectedCellRenderer,
} from 'components/tables/datagrid-columns/AmountDiffCellRenderer';
import { PhotosAntCellRenderer } from 'components/tables/datagrid-columns/PhotosCellRenderer';

const imageStyle = {
  height: '48px',
  width: '48px',
  textAlign: 'center',
};

const imagePartStyle = {
  height: '30px',
  width: '30px',
  textAlign: 'center',
};

const dateFormat = 'DD-MM-YYYY';

const getColumns = ({
  columnDefsKey,
  insurances,
  regions,
  onPhotoClick,
  user,
  visiblePartTypes,
}) => [
  {
    title: I.t('INSURANCE'),
    key: 'Ασφαλιστική',
    dataIndex: 'InsuranceID',
    width: 200,
    align: 'center',
    render: (text, record) => (
      <div style={{ textAlign: 'center' }}>
        <div>
          <span style={{ fontWeight: 600, textAlign: 'center' }}>
            {LookupsHelper.getDescription(insurances, record.InsuranceID)}
          </span>
        </div>
        <div>
          <span style={{ fontSize: 12, textAlign: 'center' }}>
            {record.ExpertUsername}
          </span>
        </div>
      </div>
    ),
  },
  {
    title: I.t('FOLDER_NO'),
    key: 'Αρ.Φακέλου',
    dataIndex: 'FolderNumber',
    align: 'center',
    width: 120,
  },
  {
    title: `${I.t('PLATE_NUMBER')}`,
    key: 'Πινακίδα',
    align: 'center',
    width: 96,
    render: (text, record) => (
      <div>
        <div>
          <span>{record.PlateNumber}</span>
        </div>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>Τ.Οχήματος</div>,
    key: 'Όχημα',
    dataIndex: 'VehicleTypeID',
    width:
      columnDefsKey === `${PartyTypes.Operator}_${AuctionStatuses.Pending}` ||
      columnDefsKey ===
        `${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`
        ? 120
        : null,
    align: 'center',
    render: (text, record) => (
      <img
        style={imageStyle}
        src={
          record.VehicleTypeID && record.VehicleTypeID === 1
            ? model
            : record.VehicleTypeID && record.VehicleTypeID === 2
            ? modelTruck
            : record.VehicleTypeID && record.VehicleTypeID === 3
            ? modelMoto
            : record.VehicleTypeID && record.VehicleTypeID === 4
            ? modelPickup
            : modelOther
        }
        alt=""
      />
    ),
  },
  {
    title: I.t('CHARACTERISTICS'),
    key: 'Χαρακτηριστικά',
    align: 'center',
    width:
      columnDefsKey === `${PartyTypes.Operator}_${AuctionStatuses.Pending}` ||
      columnDefsKey ===
        `${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`
        ? 200
        : 250,
    render: (text, record) => (
      <div>
        <div>
          <span style={{ fontWeight: 600 }}>
            {record.VehicleBrand} {record.VehicleModel}
          </span>
        </div>
      </div>
    ),
  },
  {
    title: <div style={{ textAlign: 'center' }}>{I.t('PHOTOS')}</div>,
    key: 'Φωτογραφίες',
    width: 110,
    align: 'center',
    render: (text, record) => PhotosAntCellRenderer(record, onPhotoClick),
  },
  {
    title: <div style={{ textAlign: 'center' }}>{I.t('REGION')}</div>,
    key: 'Νομός',
    dataIndex: 'RegionID',
    width: 120,
    align: 'center',
    render: (text, record) =>
      LookupsHelper.getDescription(regions, record.RegionID),
  },
  {
    key: 'Από Αρχείο',
    width: 50,
    align: 'center',
    render: (text, record) =>
      record.IsFromFile ? (
        <Tooltip title="Από Αρχείο">
          <FileTextOutlined style={{ fontSize: 16 }} />
        </Tooltip>
      ) : (
        <Tooltip title="Καταχώρηση">
          <EditOutlined style={{ fontSize: 16 }} />
        </Tooltip>
      ),
  },
  {
    title: I.t('CREATION_DATE'),
    key: 'CreatedDate',
    dataIndex: 'CreatedDate',
    width: 120,
    align: 'center',
    render: (text, record) => (
      <span>{moment(record.CreatedDate).format(dateFormat)}</span>
    ),
  },
  {
    title: I.t('END'),
    key: 'EndDate',
    dataIndex: 'EndDate',
    width: 120,
    align: 'center',
    defaultSortOrder: 'ascend',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.EndDate - b.EndDate,
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <span>{moment(record.EndDate).format(dateFormat)}</span>
      </div>
    ),
  },
  {
    dataIndex: 'photos',
    key: 'Photos',
    width: 40,
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/auctionsFolder/' + record.ID}
          className="red action-button"
          icon="fas fa-camera"
          text={I.t('PHOTOS')}
        />
      </div>
    ),
  },
  {
    dataIndex: 'folder',
    key: 'Folder',
    width: 40,
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/auctionsFolder/' + record.ID}
          className="blue action-button"
          icon="far fa-folder-open"
          text={I.t('FOLDER_C')}
        />
      </div>
    ),
  },
];

const getPartColumns = ({
  onSetAuctionToStartId,
  onSetAuctionToCancel,
  onSetAuctionToAccept,
  onSetAuctionToDispatch,
  onBidClick,
  onOfferClick,
  visiblePartTypes,
  user,
}) => [
  // {
  //   title: '',
  //   key: _.uniqueId(),
  //   width: 40,
  //   render: (text, record) => <img style={imagePartStyle} src={part} alt="" />,
  // },
  {
    title: I.t('ID'),
    key: 'ID',
    dataIndex: 'ID',
    width: 80,
    align: 'center',
    render: (text, record) => (
      <span>
        <img style={imagePartStyle} src={part} alt="" />
        {` ${record.ID}`}
      </span>
    ),
  },
  {
    title: I.t('PART_NUMBER'),
    dataIndex: 'PartNumber',
    key: 'PartNumber',
    width: 100,
  },
  {
    title: I.t('DESCRIPTION'),
    dataIndex: 'PartDescription',
    key: 'PartDescription',
    width: 200,
  },
  {
    dataIndex: 'PartPrice',
    title: I.t('INITIAL_PRICE_SHORT'),
    key: 'Αρχ.Τιμή',
    width: 100,
    align: 'center',
    render: formatCurrency,
  },
  {
    dataIndex: 'Bids',
    key: 'Προσφορές',
    width: 80,
    align: 'center',
    title: I.t('OFFERS'),
    render: getBidsTooltipCellRenderer(visiblePartTypes),
  },
  {
    title: I.t('REMAINING_TIME_SHORT'),
    key: 'Υπ. Χρόνος',
    dataIndex: 'EndDate',
    width: 80,
    align: 'center',
    defaultSortOrder: 'ascend',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.EndDate - b.EndDate,
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TimeCellRenderer
          value={moment(record.EndDate).toDate()}
          onlineMode={record.OnlineMode}
        />
      </div>
    ),
  },
  {
    dataIndex: 'Bids',
    key: 'Clickable Προσφορές',
    width: 110,
    align: 'center',
    title: I.t('OFFERS'),
    render: getBidsTooltipCellRenderer(visiblePartTypes, onBidClick),
  },
  {
    title: 'Best',
    key: 'Best',
    width: 100,
    align: 'center',
    render: (text, record) =>
      getLowestBidAmountDiffCellRenderer(
        visiblePartTypes,
        record.Bids,
        record.PartPrice
      ),
    // render: (text, record) =>
    //   record.Bids.length === 0 ? (
    //     0
    //   ) : (
    //     <span style={{ fontSize: 16, fontWeight: 600, color: '#468847' }}>
    //       {formatCurrencyRounded(findBestOffer(record.Bids))}
    //     </span>
    //   ),
  },
  {
    title: 'Selected',
    key: 'Selected',
    width: 100,
    align: 'center',
    render: (text, record) =>
      getSelectedCellRenderer(visiblePartTypes, record.Bids),
  },
  {
    title: I.t('OFFER'),
    key: 'Αποδεχθείσα Προσφορά',
    width: 100,
    align: 'center',
    render: (text, record) =>
      getLowestBidAmountDiffCellRenderer(
        visiblePartTypes,
        record.Bids,
        record.PartPrice
      ),
  },
  {
    title: I.t('OFFER'),
    key: 'Προσφορά Εμπόρου',
    width: 100,
    align: 'center',
    fixed: 'right',
    render: (
      <div className="cell-fix-wrap">{getMerchantLowestBidAmount(user)}</div>
    ),
  },
  {
    dataIndex: 'bid',
    key: 'Προσφορά',
    width: 80,
    align: 'center',
    fixed: 'right',
    render: (_, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={e => onOfferClick(record, e)}
          className="green action-button"
          icon="gavel"
          text={I.t('OFFER')}
          style={{ marginRight: 3 }}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    key: 'Αποδοχή',
    width: 80,
    align: 'center',
    fixed: 'right',
    render: (_, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={() => onSetAuctionToAccept(record)}
          className="green action-button"
          icon="check-square"
          text={I.t('ACCEPTANCE')}
          style={{ marginRight: 3 }}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    dataIndex: 'dispatch',
    key: 'Παράδοση',
    width: 80,
    render: (_, record) => (
      <div>
        <TooltipButton
          onClick={() => onSetAuctionToDispatch(record)}
          className="green action-button"
          icon="truck"
          text={I.t('DELIVERY')}
          style={{ marginRight: 3 }}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    dataIndex: 'forselection',
    key: 'Επιλογή',
    width: 80,
    render: (_, record) => (
      <div>
        {(!Array.isArray(record.Bids) || record.Bids.length === 0) && (
          <TooltipButton
            onClick={() => onSetAuctionToCancel(record)}
            className="red action-button"
            icon="times"
            text={I.t('CANCEL')}
            style={{ marginRight: 3 }}
          />
        )}
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    dataIndex: 'settings',
    key: 'Ρυθμίσεις',
    width: 40,
    render: (text, record) => (
      <TooltipLink
        to={'/auctions/' + record.ID}
        className="blue action-button"
        icon="info-circle"
        text={I.t('MORE')}
      />
    ),
  },
  {
    dataIndex: 'activate',
    key: 'Ενεργοποίηση',
    width: 40,
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={() => onSetAuctionToStartId(record.ID)}
          className="green action-button"
          icon="flag-checkered"
          text={I.t('APPROVAL')}
          style={{ marginRight: 3 }}
        />
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
  {
    key: 'Λεπτομέρειες',
    width: 60,
    align: 'center',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipLink
          to={'/auctions/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
];

export { getColumns, getPartColumns };
